import React, { useEffect, useContext } from "react";
import { Section, SidebarLayout } from "../../../../components/shared";
import {
  MenuContext,
  ServicesLayerProvider
} from "../../../../contexts/shared";
import {
  ServicesMonitoringPanedTables
} from "../../../../components/expert/services/monitoring";
import { ScheduledExpertServiceService } from "../../../../services";

export function TrackingMonitoringServicesIndex() {
  const { setMenuState } = useContext(MenuContext);

  useEffect(() => {
    setMenuState({
      openKeys: ["experts"],
      selectedKeys: ["experts/monitoring"]
    });
  }, []);

  return (
    <ServicesLayerProvider services={{
      ScheduledExpertServiceService
    }}>
      <SidebarLayout>
        <Section spaced>
          <ServicesMonitoringPanedTables
            tableType="TRACKING" />
        </Section>
      </SidebarLayout>
    </ServicesLayerProvider>
  );
}
